import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import PersonalReportConfig from "../model/PersonalReportConfig";

export default class InitializePersonalReportConfigTask extends Task {
    /**
     * Task to load and initialize GoogleAnalytics
     * @param {soma.EventDispatcher} dispatcher - the soma EventDispatcher
     * @param {PersonalReportConfig} personalReportConfig
     * @param {AssetLibrary} assetLibrary
     */
    constructor(dispatcher, personalReportConfig, assetLibrary) {
        super();
        this._dispatcher = dispatcher;
        this._personalReportConfig = personalReportConfig;
        this._assetLibrary = assetLibrary;
    }

    execute(callback) {
        const configObj = this._assetLibrary.getAsset('personalReportConfig');
        this._personalReportConfig.setPropertiesFromObject(configObj);

        callback();
    }
}
